<template>
    <!--콘텐츠 영역-->
    <div class="mainbusiness_wrap">
        <div id="sub_contents" class="mainbusiness education">
            <div class="tit">
                <div>SONGWON FOUNDATION</div>
                <h3>송원문화재단은 2004년부터<br>
                    전국의 우수 이공계 장학생 선발을<br>
                    통해 장학금을 지원하고있습니다.
                </h3>
                <p>
                    이를 통해 대한민국의 우수한 인재를 양성하고 미래사회 일원으로 발돋움 할 수 있도록 돕고자합니다.<br>
                    또한 기업이익을 지역사회에 환원하고 부산시민의 은혜에 보답한다는 재단설립의 취지에따라,
                    생활형편이 어려운 학생의 장학금과 생활비를 지원하였습니다.
                </p>
            </div>
            <div class="cont_wrap" style="height:1750px;">
                <div class="cont">
                    <div><img :src="require('./../../assets/img/sub/01/edusupport2.png')" /></div>
                    <div>
                        <h3>송원 이공계 장학생</h3>
                        <span>이공계 장학생 장학증서 수여</span>
                        <p>
                            송원문화재단은 지방대학의 우수한 인재 육성을 위해 이공계 대학생을 선발하여 4학기 연속 등록금 전액을 지원합니다.
                            또한 송원 이공계 장학생이 동국제강 대졸공채 및 주니어사원 입사 지원 시 가점을 제공합니다.
                        </p>
                        <a href="/notice/detail?id=64ae667cdfe7c83faae0e6da&type=1">자세히 보기 +</a>
                    </div>
                </div>
                <div class="cont">
                    <div><img :src="require('./../../assets/img/sub/01/edusupport1.png')" /></div>
                    <div>
                        <h3>제20기 송원장학생 장학증서 수여식</h3>
                        <span>이공계 장학생 13명 장학증서 수여</span>
                        <a href="/notice/detail?id=64ae688edfe7c83faae0e700&type=1">자세히 보기 +</a>
                    </div>
                </div>
                <div class="cont">
                    <div><img :src="require('./../../assets/img/sub/01/edusupport3.png')" /></div>
                    <div>
                        <h3>송원 오륙도 장학생</h3>
                        <span>장학생 10명 선발, 장학금 지급</span>
                        <p>
                            부산 남구 초∙중∙교 학생을 선발하여 매월 장학금을 지원합니다.
                            기업이익을 지역사회에 환원하고, 부산시민의 은혜에 보답한다는 재단설립취지를 따라 장학생을 선발하고 있습니다.
                            또한 재단 내 멘토링을 통해 경제적·정서적 지원이 이뤄질 수 있도록 하여 학생에게 실질적 도움을 제공하는 사업을 진행하고 있습니다.
                        </p>
                        <a href="/notice/detail?id=64ae68fcdfe7c83faae0e70b&type=1">자세히 보기 +</a>
                    </div>
                </div>
                <div class="cont">
                    <div><img :src="require('./../../assets/img/sub/01/edusupport4.png')" /></div>
                    <div>
                        <h3>송원 유엔평화 장학생</h3>
                        <span>모범장병 3명 장학증서 수여</span>
                        <p>자주국방과 부산시민의 안전을 책임지는 모범장병을 선발하여 제대 후 복학하여<br>
                            학업에 집중할 수 있도록한 학기 등록금 전액을 지원하고 있습니다.</p>
                        <a href="/notice/detail?id=64b62a49dfe7c83faae0e830&type=1">자세히 보기 +</a>
                    </div>
                </div>
                <div class="cont">
                    <div><img :src="require('./../../assets/img/sub/01/edusupport5.png')" /></div>
                    <div>
                        <h3>송원 유엔평화 장학생</h3>
                        <span>모범장병 3명 장학증서 수여</span>
                        <a href="/notice/detail?id=64b62a49dfe7c83faae0e830&type=1">자세히 보기 +</a>
                    </div>
                </div>
            </div>
        </div>
        <!--
        <div class="support_list">
            <div class="mainbusiness">
                <ul>
                    <li>
                        <h3>송원 이공계 장학생</h3>
                        <p>
                            송원문화재단은 지방대학의 우수한 인재 육성을 위해 이공계 대학생을 선발하여 4학기 연속
                            등록금 전액을 지원합니다. 또한 송원 이공계 장학생이 동국제강 대졸공채 및 주니어사원
                            입사 지원 시 가점을 제공합니다.
                        </p>
                    </li>
                    <li>
                        <h3>송원 오륙도 장학생</h3>
                        <p>
                            부산 남구 초∙중∙교 학생을 선발하여 매월 장학금을 지원합니다. 기업이익을 지역사회에 환원하고,
                            부산시민의 은혜에 보답한다는 재단설립취지를 따라 장학생을 선발하고 있습니다.
                            또한 재단 내 멘토링을 통해 경제적·정서적 지원이 이뤄질 수 있도록 하여 학생에게 실질적
                            도움을 제공하는 사업을 진행하고 있습니다.
                        </p>
                    </li>
                    <li>
                        <h3>그 외</h3>
                        <p>
                            송원빌딩 입주업체 연계 학습비 지원사업, 에스모드(ESMOD) 서울재단 장학생 선발, 그룹홈
                            교육지원 학습비 지원사업, 유엔평화 장학생 선발 등 다양한 공익활동을 추진하고 있습니다.
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        -->
        <div class="process">
            <div class="mainbusiness">
                <div><img :src="require('./../../assets/img/sub/01/process.png')" /></div>
                <div>
                    <h3>장학생 선발 방식</h3>
                    <dl>
                        <dt>지원자격</dt>
                        <dd>부산 남구 초∙중∙고 학생</dd>
                    </dl>
                    <dl>
                        <dt>선발인원</dt>
                        <dd>00명</dd>
                    </dl>
                    <dl>
                        <dt>선발절차</dt>
                        <dd>온라인 지원 > 서류심사 > 면접 > 선발</dd>
                    </dl>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    data: () => ({
        message: "Brochure.vue"
    }),
    methods: {},
    computed: {
        IS_MOBILE() {
            return this.$root.$data.isMobileMode;
        }
    },
    destroyed() { },
    created() {
        console.log("created - " + this.message);
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sub01/EducationSupport.vue